import { UserGetResultT } from 'ui-io/user-io'

type NormalizeUserQueryData = {
  data: UserGetResultT | undefined
  username: string
}

const normalizeUserQueryData = ({ data, username }: NormalizeUserQueryData) => {
  const email = data?.user.properties?.email
  const firstName = data?.user.properties?.first_name
  const lastName = data?.user.properties?.last_name
  const displayName = `${firstName ?? ''} ${lastName ?? ''}`.trim() || username

  return {
    email,
    firstName,
    lastName,
    displayName,
  }
}

export default normalizeUserQueryData
